import { defa }     from 'defa-object';
import ControlModel from 'scripts/poppet/control-model';

/**
 * defa.models.Thermostat
 * The DEFA Thermostat model.
 * @version 1.2.0
 */

const apiHost = defa.vars.apiHost;
const api = {
	linkcom   : apiHost + '/linkcom/',
	zone      : '/zone',
	thermostat: '/thermostat?attrs=',
};

const Thermostat = ControlModel.extend( {
	
	url: function() {
		return api.linkcom + this.get('unitId') + api.zone +
				this.get('zoneNumber') + api.thermostat + this.getAttributes();
	},
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	defaults: _.extend( {}, ControlModel.prototype.defaults,
		{
			localTemperature         : null, // Measured temperature
			unoccupiedCoolingSetpoint: null, // Stop heating at > this * 100. Used when zone is set to Away.
			occupiedCoolingSetpoint  : null, // Stop heating at > this * 100. Used when it is day and zone is set to In.
			currentCoolingSetpoint   : null, // Currently active cooling setpoint. Stop heating at > this * 100.
			nightCoolingSetpoint     : null, // Stop heating at > this * 100. If night mode is activated, then used
											 // when it is night and zone is set to In, else OccupiedCoolingSetpoint is used.
			unoccupiedHeatingSetpoint: null, // Start heating at < this * 100. Used when zone is set to Away.
			occupiedHeatingSetpoint  : null, // Start heating at < this * 100. Used when it is day and zone is set to In.
			currentHeatingSetpoint   : null, // Currently active heating setpoint. Start heating at < this * 100.
			nightHeatingSetpoint     : null, // Start heating at < this * 100. If night mode is activated, then used
											 // when it is night and zone is set to In, else OccupiedHeatingSetpoint is
											 // used.
			localTemperatureError        : null,
			unoccupiedCoolingSetpointError : null,
			occupiedCoolingSetpointError   : null,
			currentCoolingSetpointError    : null,
			nightCoolingSetpointError      : null,
			unoccupiedHeatingSetpointError : null,
			occupiedHeatingSetpointError   : null,
			currentHeatingSetpointError    : null,
			nightHeatingSetpointError      : null
		} ),
	
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	parse: function( response, options ) {
		//Do a check to decide if response is valid for parsing
		if(response) {
			let newModelAttributes = {};
			if(response.localTemperature){
				this.parseAttribute('localTemperature', response.localTemperature, options, newModelAttributes)
			}
			if(response.unoccupiedHeatingSetpoint){
				this.parseAttribute('unoccupiedHeatingSetpoint', response.unoccupiedHeatingSetpoint, options, newModelAttributes)
			}
			
			if(response.unoccupiedCoolingSetpoint){
				this.parseAttribute('unoccupiedCoolingSetpoint', response.unoccupiedCoolingSetpoint, options, newModelAttributes)
			}
			
			if(response.occupiedCoolingSetpoint){
				this.parseAttribute('occupiedCoolingSetpoint', response.occupiedCoolingSetpoint, options, newModelAttributes)
			}
			
			if(response.currentCoolingSetpoint){
				this.parseAttribute('currentCoolingSetpoint', response.currentCoolingSetpoint, options, newModelAttributes)
			}
			
			if(response.nightCoolingSetpoint){
				this.parseAttribute('nightCoolingSetpoint', response.nightCoolingSetpoint, options, newModelAttributes)
			}
			
			if(response.occupiedHeatingSetpoint){
				this.parseAttribute('occupiedHeatingSetpoint', response.occupiedHeatingSetpoint, options, newModelAttributes)
			}
			
			if(response.currentHeatingSetpoint){
				this.parseAttribute('currentHeatingSetpoint', response.currentHeatingSetpoint, options, newModelAttributes)
			}
			
			if(response.nightHeatingSetpoint){
				this.parseAttribute('nightHeatingSetpoint', response.nightHeatingSetpoint, options, newModelAttributes)
			}
			
			newModelAttributes.modelError = null;
			this.receivedData( newModelAttributes );
			this.set(newModelAttributes);
		}
	},

	//TODO! internalCompensation is also an attribute for this cluster, but something is wrong with it, so leaving it out from here.
	getAttributes: function() {
		return 'localTemperature,unoccupiedCoolingSetpoint,unoccupiedHeatingSetpoint,currentCoolingSetpoint,nightCoolingSetpoint,occupiedHeatingSetpoint,' +
		        'occupiedCoolingSetpoint,currentHeatingSetpoint,nightHeatingSetpoint';
	},
	
	updateCurrent: function (){
		this.fetch( {
			url: api.linkcom + this.get('unitId') + api.zone +
				 this.get('zoneNumber') + api.thermostat + 'currentHeatingSetpoint,currentCoolingSetpoint'
		} );
	},
	
	toBackendJSON: function() {
		return {
			unoccupiedCoolingSetpoint: this.get( 'unoccupiedCoolingSetpoint' ),
			occupiedCoolingSetpoint  : this.get( 'occupiedCoolingSetpoint' ),
			nightCoolingSetpoint     : this.get( 'nightCoolingSetpoint' ),
			unoccupiedHeatingSetpoint: this.get( 'unoccupiedHeatingSetpoint' ),
			occupiedHeatingSetpoint  : this.get( 'occupiedHeatingSetpoint' ),
			nightHeatingSetpoint     : this.get( 'nightHeatingSetpoint' ),
		};
	}
	
} );

export default Thermostat;
